/**
 * How recently a running session was used. One definition for the computer (which trims what it keeps for quiet sessions)
 * and the phone (which folds them away), so both agree.
 *   active   used within the last hour: streamed live, full scrollback
 *   idle     an hour to a day untouched: still listed normally, smaller scrollback on the computer
 *   dormant  over a day untouched: folded under "Idle" on the phone, minimal scrollback
 * A computer too old to say when a session was last used (no `lastActivityAt`) counts as active.
 */
export type SessionActivity = "active" | "idle" | "dormant";

export const ACTIVE_WITHIN_MS = 60 * 60_000;
export const DORMANT_AFTER_MS = 24 * 60 * 60_000;
/** A session untouched this long is offered for ending in one tap. */
export const STALE_AFTER_MS = 7 * 24 * 60 * 60_000;

export function sessionActivity(s: { status: "running" | "exited"; lastActivityAt?: number }, now: number): SessionActivity {
  if (s.status !== "running" || s.lastActivityAt === undefined) return "active";
  const quiet = now - s.lastActivityAt;
  return quiet > DORMANT_AFTER_MS ? "dormant" : quiet > ACTIVE_WITHIN_MS ? "idle" : "active";
}
